<template>
  <div style="">
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover"
    >
    <van-number-keyboard safe-area-inset-bottom />

    <van-nav-bar left-text="返回" title="票据上传" left-arrow @click-left="onClickLeft" />
    <van-nav-bar :left-text="'您好，' + userInfo.emp_name +'，累计上传'+file.count +'张票据'" right-text="" />
    <div >
      <van-tabbar v-show="activeTabbar === 'history'" >
        <van-pagination v-model="queryCondition.page" :total-items="queryCondition.total" :show-page-size="4" force-ellipses @change="onCollapseChange(null)" />
      </van-tabbar>
    </div>
    <van-panel v-if="uploadData.selectedClient" :title="uploadData.selectedClient.sname" :desc="uploadData.selectedClient.name" :status="uploadData.statusName" />
    <van-tabbar v-model="activeTabbar" safe-area-inset-bottom >
      <van-tabbar-item name="history" icon="home-o">历史上传记录</van-tabbar-item>
      <van-tabbar-item name="upload" icon="search">票据上传</van-tabbar-item>
    </van-tabbar>

    <div v-if="activeTabbar === 'upload'">
      <van-steps :active="3">
        <van-step>开始拍照</van-step>
        <van-step>等待上传</van-step>
        <van-step>上传完成</van-step>
      </van-steps>
      <van-row type="flex" justify="center">
        <van-col span="8" style="" />

        <van-col span="8" style=" text-align: center;">
          <van-uploader
            v-model="fileList"
            :max-count="99"
            :disabled="!canUpload"
            :deletable="canUpload"
            :after-read="afterRead"
            :before-delete="beforeDelete"
            accept="*"
            upload-text="请选择文件"
            multiple
          />
        </van-col>
        <van-col span="8" style="" />
      </van-row>
    </div>

    <div v-if="activeTabbar === 'history'" style="height: 100%; margin-bottom: 100px; ">

      <van-row>
        <van-col :span="18"><!-- <van-field label="票据账期" placeholder="2020-10-01" input-align="right" readonly disabled /> --></van-col>

      </van-row>
      <van-row style="border: 1px solid gainsboro;height: 50px;line-height: 50px;overflow: hidden;" >
        <van-col span="18" class="tip-msg" style="text-align: center;">提示:点击上传记录，可查看上传文件明细！</van-col>
        <van-col :span="6" style="text-align: center;"><base-button type="warning" @click="getElecnotes">刷新</base-button></van-col>

      </van-row>
      <!-- <van-row class="list-title">
        <van-col span="8">上传时间</van-col>
        <van-col span="8">账期</van-col>
        <van-col span="8">批次</van-col>
      </van-row> -->
      <!-- <template v-if="elecnotesList && elecnotesList.length > 0">
        <van-cell
          v-for="elec in elecnotesList"
          :key="elec.id"
          class="list-tip"
          @click="
            onCollapseChange(elec);
            showDetails = true;
          "
        >
          <van-col span="8" style="text-align: center;">{{ elec.create_time }}</van-col>
          <van-col span="8" style="text-align: center;">{{ elec.curr_date }}</van-col>
          <van-col span="8" style="text-align: center;">{{ elec.batch }}</van-col>
        </van-cell>
      </template> -->

      <!-- <template v-else>
        <van-col span="24" class="list-tip">{{ tip }}</van-col>
      </template> -->

      <div>
        <van-popup v-model="show" closeable round style="width: 400px;">
          <!-- <div v-for="(File, index) in FileListImag" :key="File.id" style=" padding-left:5%;"> -->
          <span style="height: 50px;display: block; " />
          <van-row type="flex" justify="center">
            <van-col span="20">
              <viewer id="imageUrlsCourseSource " z-index-inline="4000"><img :src="src" width="350" height="150" @click="show = false" ></viewer>
            </van-col>
            <van-col span="2"><van-button size="mini" plain hairline type="danger" style="margin-left: 33px;height: 40px;" @click="beforeDelete">删除</van-button></van-col>
          </van-row>
          <!-- </div> -->
        </van-popup>
      </div>

      <van-popup :style="{ height: '90%','margin-bottom':'50px' }" v-model="showDetails" position="top" closeable>
        <br >
        <br >
        <van-tabs v-model="activeHistory">
          <van-tab v-for="step in steps" :key="step.id" :title="step.name">
            <van-col v-for="file in step.historyOtherList" :key="file.id" :span="24" style="text-align: left">
              <a :href="BACKEND_API + '/' + file.img_url + '?token=' + token" target="_blank">{{ file.fileName }}</a>
            </van-col>
            <van-col v-for="(image, index) in step.historyImageList" :key="image.id" :span="6" style="text-align: center">
              <van-image :src="BACKEND_API + '/' + image.img_url + '?token=' + token" width="80" height="80" @click="onPreview(index)" />
            </van-col>
          </van-tab>
        </van-tabs>
        <van-col :span="24" style="text-align: center"><base-button @click="showDetails = false">关闭</base-button></van-col>
      </van-popup>
      <van-image-preview v-model="showPreview" :images="imagesUrlList" :start-position="startPosition" :closeable="true" />
      <div v-for="(list, index) in imagesUrlList" :key="index" style=" line-height: 0px; ">
        <van-swipe-cell style="">
          <div style=" position: relative;top: 90px;z-index: 100000;">
            <van-row type="flex" justify="space-between" style="text-align: center;">
              <van-col span="6" />
              <van-col span="5" style="font-size: 15px; text-align: left;color: #606266;">{{ list.name }}</van-col>
              <van-col span="8" style="color: #CFCFCF"/>
            </van-row>
          </div>
          <van-card
            :thumb="list.url"
            :desc="list.time"
            style="  border:1px solid #D3D3D3;
 background-color:#F7F7F7;
 "
            title="上传时间"
            class="goods-card"
            @click="xaa(list)"
          />
          <template #right>
            <van-button square text="删除" type="danger" class="delete-button" @click="beforeDelete(list)" />
          </template>
        </van-swipe-cell>
      </div>

    </div>

    <init :init-states="initStates" @after-init="init" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getLastBatch, getElecnotesList, getAiElecnotesDetail, uploadElecnotes, deleteFile } from '@/api/elecnotes';

import Viewer from 'v-viewer';
import Init from '@/components/base/init';
export default {
  name: 'UploadFileTx',
  components: { Init },

  data() {
    return {
      fileList: [],
      up: true,
      show: false,
      showDatePicker: false,
      showDetails: false,
      showPreview: false,
      active: 0,
      activeHistory: 0,
      activeTabbar: 'upload',
      uploading: false,
      uploadingMsg: '',
      uploadingPercentage: 0,
      tip: this.CONST.EMPTY_MSG,
      canUpload: false,
      Img_id: 0,
      selectedDate: null,
      elecnotesList: [],
      imagesUrlList: [],
      imagetiktok: [],
      startPosition: 0,
      src: '',
      id: [],
      fileOrd: 1,
      uploadData: {
        token: null,
        ele_id: null,
        selectedClient: null,
        client_id: null,
        batch: null,
        is_phone: true,
        curr_date: null,
        statusName: ''
      },
      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',
        client_name: '',
        name: ''
      },
      fomm: [],
      file: { count: 0 },
      steps: [
        {
          id: '1',
          name: '上月完税',
          fileList: [],
          historyOtherList: [],
          historyImageList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '2',
          name: '本月收入票',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '3',
          name: '银行收付',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '4',
          name: '成本费用票',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '5',
          name: '辅助资料',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        }
      ],
      initStates: [
        {
          key: 'app/initCurrentDate'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['token', 'userInfo', 'currentDate', 'selectedClient'])
  },
  mounted() {
    this.onCollapseChange(null);
  },
  methods: {
    init() {
      this.uploadData.token = this.token;
      this.uploadData.curr_date = this.currentDate;
      // this.selectedDate = this.currentDate;
      this.selectedDate = '2020-10-01';
      if (sessionStorage.getItem('id') !== undefined) {
        this.getElecnotes();

        this.canUpload = true;
      } else {
        this.error('请先选择票据类型，再操作票据上传');
      }
    },
    initImageTools() {
      // 初始化 viewerjs
      const ViewerDom = document.getElementById('imageUrlsCourseSource');
      new Viewer(ViewerDom, {
        // 相关配置项,详情见下面
        zIndex: 3018
      });
      const viewer = new Viewer(ViewerDom, { url: 'src' });
    },
    xaa(val) {
      
      this.show = true;
      this.src = val.url;
      this.Img_id = val.id;

      // this.file.obj.id = val.id;
    },
    onClickLeft() {
      this.$router.go(-1);
      this.toast('选择票据类型');
    },
    onPreview(index) {
      this.startPosition = index;
      this.showPreview = true;
    },
    query() {
      this.id = [];
      this.axios.post('/elecnotes/leisure-type', { token: this.token }).then(res => {
        for (let i = 0; i < res.data.rows.length; i++) {
          this.id.push({ ele_type: res.data.rows[i].ele_type, name: res.data.rows[i].name, num: res.data.rows[i].num });
        }
        sessionStorage.setItem('ex', JSON.stringify(this.id));
      });
    },
    onCollapseChange(elec) {
      getAiElecnotesDetail({
        id: 35425,
        sign_emp_id: this.userInfo.emp_id,
        'page': this.queryCondition.page,
        'rows': this.queryCondition.rows,
        'sort': 'id',
        'order': 'desc'
      }).then(resp => {
        this.steps.forEach(step => {
          step.historyOtherList = [];
          step.historyImageList = [];
        });
        this.imagesUrlList = [];
        sessionStorage.setItem('count', resp.total);
        this.file.count = resp.total;
        const fileList = resp.rows || [];
        fileList.forEach(file => {
          const filePos = file.img_url.lastIndexOf('/');
          file.fileName = file.img_url.substring(filePos + 1);
          const suffixPos = file.img_url.lastIndexOf('.');
          const suffixName = file.img_url.substring(suffixPos + 1);
          file.isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null;
          let step = this.steps.find(step => step.id === file.type);
          if (!step) {
            step = this.steps[0];
          }
          if (file.isImg) {
            step.historyImageList.push(file);
            const mn = JSON.parse(sessionStorage.getItem('ex'));
            const len = mn.length;
            for (let i = 0; i < len; i++) {
              if (parseInt(mn[i].ele_type) === parseInt(file.ele_type)) {
                this.imagesUrlList.push({
                  url: this.BACKEND_API + '/' + file.img_url + '?token=' + this.token,
                  time: file.create_time,
                  name: mn[i].name,
                  num: (2000 - parseInt(mn[i].num)),
                  id: file.id
                });
                break;
              }
            }
          } else {
            step.historyOtherList.push(file);
          }
        });
        this.queryCondition.total = resp.total || 0;
      });
    },
    getLastBatchCode() {
      return new Promise((resolve, reject) => {
        this.uploadData.batch = this.Utils.df(null, '{m}{d}001');
        getLastBatch({
          client_id: parseInt(this.uploadData.client_id)
        })
          .then(resp => {
            const batch = resp.obj;
            if (this.Utils.df(null, '{m}{d}') === batch.substring(0, 4)) {
              const prefix = batch.substring(0, 4);
              const code = parseInt(batch.substring(4));
              this.uploadData.batch = prefix + this.Utils.prefixInteger(code + 1, 3);
            }
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getElecnotes() {
      this.tip = '查询中...';
      getElecnotesList({
        cx_user: this.CONST.CX_USER,
        create_id: this.userInfo.emp_id,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        client_id: 71728,
        curr_date: this.selectedDate
      })
        .then(resp => {
          this.elecnotesList = resp.rows || [];
          if (this.elecnotesList.length === 0) {
            this.tip = this.CONST.EMPTY_MSG;
          }
          this.query();

          this.onCollapseChange(null);
        })
        .catch(() => {
          this.tip = this.CONST.EMPTY_MSG;
        });
    },
    beforeDelete(file) {
      return new Promise((resolve, reject) => {
        if (file.id > 0) {
          this.Img_id = file.id;
        }
        deleteFile({
          id: this.Img_id > 0 ? this.Img_id : file.obj.id
        }).then(resp => {
          if (resp.success) {
            this.show = false;
            this.query();
            this.onCollapseChange(null);
            resolve();
            this.toast(resp.msg);
          } else {
            reject();
          }
        });
      });
    },
    async afterRead(file) {
      this.canUpload = false;
      this.uploading = true;
      this.uploadingPercentage = 0;
      let files = [];
      if (file instanceof Array) {
        files = file;
      } else {
        files.push(file);
      }
      for (let i = 0; i < files.length; i++) {
        this.uploadingPercentage = parseFloat(parseFloat(((i + 1) / files.length) * 100).toFixed(2));
        this.uploadingMsg = ` ${i + 1}/${files.length}`;

        const originFile = files[i];
        const suffixPos = originFile.file.name.lastIndexOf('.');
        const suffixName = originFile.file.name.substring(suffixPos + 1);
        const isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null;

        if (isImg) {
          const rst = await this.lrz(originFile.file);
          rst.formData.append('client_id', 74734);
          rst.formData.append('ele_id', 36455);
          rst.formData.append('batch', 1001001);
          rst.formData.append('curr_date', '2020-10-01');
          rst.formData.append('is_ticket_ai', true);
          rst.formData.append('ele_type', parseInt(sessionStorage.getItem('ele_type')));
          // rst.formData.append('sign_emp_id', parseInt(this.userInfo.emp_id));
          // rst.formData.append('create_id', parseInt(this.userInfo.emp_id));
          await this.uploadFile(originFile, rst.formData, this.fileOrd++).catch(() => {
            this.error('文件上传失败');
          });
        } else {
          const formData = new FormData();
          formData.append('file', originFile.file);
          await this.uploadFile(originFile, formData, this.fileOrd++).catch(() => {
            this.error('文件上传失败');
          });
        }
      }
      this.canUpload = true;
      this.uploading = false;
      this.uploadingPercentage = 100;
    },
    uploadFile(originFile, formData, ord) {
      return new Promise((resolve, reject) => {
        for (const key in this.uploadData) {
          formData.append(key, this.uploadData[key]);
        }

        uploadElecnotes(formData)
          .then(resp => {
            if (resp.success) {
              if (resp.obj) {
                originFile.obj = resp.obj;
                this.uploadData.ele_id = resp.obj.ele_id;
              }
              console.log('文件上传成功 ord: ', ord);
              this.success(resp.msg);
              this.query();
              this.onCollapseChange(null);
              this.file.count = parseInt(sessionStorage.getItem('count'));

              resolve();
            } else {
              console.error('文件上传失败 ord: ', ord);
              this.delFile(originFile);
              reject(resp.msg);
            }
          })
          .catch(error => {
            console.error('文件上传失败 ord: ', ord);
            this.delFile(originFile);
            reject(error.message);
          });
      });
    },
    delFile(step, file) {
      const index = step.fileList.indexOf(file);
      if (index !== -1) {
        step.fileList.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
.goods-card {
  margin: 0;

  display: block;
  /* background-color: #DFF0D8; */
}

.delete-button {
  height: 100%;
line-height: 95%;
  border:1px solid #aaffff;
}
.van-tabbar--fixed >>> .van-pagination {
  margin: 0 auto;
  position: relative;
  bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/elecnotes/upload-file-tx.vue